import { useState, useEffect, useRef } from "react";

interface WasmModule {
  calculatePrayerTimes(
    year: number,
    month: number,
    day: number,
    latitude: number,
    longitude: number,
    elevation: number,
    method: string,
    asrMethod: string,
    utcOffset: number
  ): {
    fajr: string;
    sunrise: string;
    dhuhr: string;
    asr: string;
    maghrib: string;
    isha: string;
  };
  suggestMethod(latitude: number, longitude: number): string;
  listMethods(): Array<{ key: string; name: string; region: string }>;
}

interface UseWasmReturn {
  module: WasmModule | null;
  ready: boolean;
  error: Error | null;
}

export function useWasm(): UseWasmReturn {
  const [module, setModule] = useState<WasmModule | null>(null);
  const [error, setError] = useState<Error | null>(null);
  const initRef = useRef(false);

  useEffect(() => {
    if (initRef.current) return;
    initRef.current = true;

    async function loadWasm() {
      try {
        const wasm = await import("@/wasm-pkg/miqat_engine");
        await wasm.default();
        setModule(wasm as unknown as WasmModule);
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error("Failed to load Wasm module")
        );
      }
    }

    loadWasm();
  }, []);

  return { module, ready: module !== null, error };
}
